import { useCallback, useState } from "react";
import { X } from "lucide-react";
import { ModalPortal } from "../ModalPortal/ModalPortal";
import { CircularProgress } from "../CircularProgress/CircularProgress";
import { useNotification } from "../Notification/NotificationProvider";
import { getApiErrorMessage } from "../../utils/getApiErrorMessage";
import "./UnconfirmedEmailModal.scss";

interface UnconfirmedEmailModalProps {
  email: string;
  onClose: () => void;
  onResend: (email: string) => Promise<unknown>;
}

export const UnconfirmedEmailModal = ({
  email,
  onClose,
  onResend,
}: UnconfirmedEmailModalProps) => {
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleResend = useCallback(() => {
    setLoading(true);
    setError(null);
    onResend(email.trim())
      .then(() => {
        showNotification({
          message: "Письмо для подтверждения отправлено повторно",
          variant: "success",
        });
        onClose();
      })
      .catch((err: unknown) => {
        setError(getApiErrorMessage(err, "Не удалось отправить письмо"));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [email, onClose, onResend, showNotification]);

  return (
    <ModalPortal>
      <div className="detail-checks-modal-overlay" onClick={onClose}>
        <div
          className="detail-checks-modal unconfirmed-email-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="detail-checks-modal-head">
            <h3>Почта не подтверждена</h3>
            <button
              type="button"
              className="detail-tasklist-close"
              onClick={onClose}
              aria-label="Закрыть"
            >
              <X size={18} />
            </button>
          </div>
          <div className="detail-checks-modal-body">
            <p className="unconfirmed-email-modal-text">
              Подтвердите адрес электронной почты, чтобы войти в аккаунт. Проверьте входящие
              или отправьте письмо повторно.
            </p>
            {error && <span className="unconfirmed-email-modal-error">{error}</span>}
          </div>
          <div className="detail-checks-modal-footer">
            <button
              type="button"
              className="create-request-modal-submit"
              onClick={handleResend}
              disabled={loading || !email.trim()}
            >
              {loading ? <CircularProgress size="sm" /> : "Отправить письмо повторно"}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};
